import apinode from '../../apinode'

class WmsConfBonusService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getAll() {
    const response = await apinode.get(`/wmsConfBonus/${this.idconta}`)

    return response.data
  }

  async getAllItems(bonusId) {
    const response = await apinode.get(
      `/wmsConfBonus/items/${bonusId}/${this.idconta}`,
    )

    return response.data
  }

  async create(idPedidoCompra) {
    const response = await apinode.post(`/wmsConfBonus/${this.idconta}`, {
      idPedidoCompra,
    })

    return response.data.num_bonus
  }
}

export default new WmsConfBonusService()
